import styled from 'styled-components';

import { mapColors, mapColorsHover } from "../../helpers/colorHelper";

const btnSize = (small) => {
  return small ? '32px' : '48px';
};

const getButtonPadding = (iconBtn, small, hasChildren) => {
  // buttons with icons but no text
  if (iconBtn && !hasChildren) {
    if (small) {
      return '8px';
    }
    return '14px';
  }
  // buttons with icons and text
  if (iconBtn) {
    if (small) {
      return '2px 8px';
    }
    return '14px 16px';
  }
  // buttons with only text
  if (small) {
    return '6px 16px';
  }
  return '14px 24px';
};

export const Btn = /*#__PURE__*/styled.button.withConfig({ displayName: "styles__Btn", componentId: "sc-eawxea-0" })(["position:relative;display:flex;align-items:center;justify-content:center;padding:", ";height:", ";min-width:", ";width:", ";color:", ";background-color:", ";border:2px solid ", ";border-radius:88px;box-sizing:border-box;outline:transparent;overflow:hidden;cursor:pointer;transition:all cubic-bezier(0.4,0,0.2,1) 0.3s;&:disabled{color:", ";background-color:", ";border-color:transparent;cursor:not-allowed;}&:hover,&:active{&:not(:disabled){color:", ";background-color:", ";border-color:transparent;}}"],












({ iconBtn, small, hasChildren }) =>
getButtonPadding(iconBtn, small, hasChildren),
({ small }) => btnSize(small),
({ small }) => btnSize(small),
({ fullWidth }) => fullWidth ? '100%' : 'fit-content',

({ theme, color, outlined }) =>
outlined ?
mapColors({
  theme,
  color: color === 'grey' || color === 'white' ? theme.colors.Foreground : color }) :

(color === 'grey' || color === 'white') && theme.colors.Foreground ||
theme.colors.Background,
({ theme, outlined, color }) =>
outlined ? 'transparent' : mapColors({ theme, color }),

({ theme, outlined, borderColor }) =>
outlined ? borderColor || theme.colors['Level 1'] : 'transparent',








({ theme }) => theme.colors['Level 1'],
({ theme }) => theme.colors['Level 1'],







({ theme, color }) =>
color === 'black' || color === 'grey' || color === 'white' ?
theme.colors.Foreground :
theme.colors.Background,
({ theme, color, outlined }) =>
outlined ? mapColors({ theme, color }) : mapColorsHover({ theme, color }));





export const BtnContent = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__BtnContent", componentId: "sc-eawxea-1" })(["", ";display:flex;align-items:center;overflow:hidden;max-width:100%;"],
({ theme }) => theme.typography.SmallHeadline);






export const BtnText = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__BtnText", componentId: "sc-eawxea-2" })(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);





export const BtnIcon = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__BtnIcon", componentId: "sc-eawxea-3" })(["display:inline-flex;align-self:center;color:currentColor;fill:currentColor;max-width:", ";&:only-child{justify-self:center;}&:not(:only-child){margin-right:8px;}"],




({ small }) => small ? '20px' : '24px');